import styled from 'styled-components';
import wixService from '../../../../../../services/wixService';

function getScrollBarBG(stripColor) {
  try {
    if (typeof stripColor !== 'undefined' && stripColor !== '') {
      return wixService.getTinycolor(stripColor).setAlpha(0.3).toRgbString();
    }
  } catch (e) {
    console.log('e:', stripColor);
    return stripColor;
  }
}

export const CusttomScrollBar = styled.div`
  &.fixedScrollBar.fixedScrollbarHeight {
    height: 200px !important;
  }
  &.fixedScrollbar::-webkit-scrollbar-thumb {
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorByreference(props.design.questionText.color.value),
      )};
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        ),
      )};
  }
`;

export const IconWrapper = styled.div`
  fill: ${(props) =>
    wixService.getColorByreference(
      props.design.questionText.color.value,
    )} !important;
  fill: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.design.questionText.color.name,
    )} !important;
`;
